import styled from "styled-components";
import greenbor from "../../assets/images/1.svg";

function circleMap() {
  let style = "";

  let scale = 1.65; // scale

  let miniScale = 1;

  let opa = 1; //opacity

  for (let i = 1; i <= 3; i++) {
    style += `
    .circle${i} {
      &::after {
        content: url('Ellipse.svg');
        position: absolute;
        top: 110px;
        left: 0;
        opacity: ${opa};
        right: 109px;
        bottom: 0;
        scale: ${scale};
        @media (max-width: 600px) {
          top: -21px;
          right: -15px;
          scale: ${miniScale};
        }
        @media (max-width: 480px) {
          display: none;
        }
      }
    }
    `;
    scale += 0.2;
    miniScale += 0.2;
    opa -= 0.2 * i;
  }
  return style;
}

export const HeroCircleContainer = styled.div`
  position: relative;
  width: 510px;
  height: 510px;
  border-radius: 50%;
  background-color: var(--primary-color);
  ${circleMap()};
  opacity: 76%;
  position: absolute;
  right: 5%;
  top: 30%;
  @media (max-width: 600px) {
    width: 300px;
    height: 300px;
  }
  @media (max-width: 480px) {
    width: 100%;
    height: auto;
    border-radius: 0;
    right: 0;
    top: 40px;
    background-color: unset;
  }
`;

// export const HeroCircleSecond = styled.section`
//   width: 600px;
//   height: 600px;
//   border-radius: 50%;
//   border-right: 1px solid rgba(18, 164, 111, 40%);
//   border-top: 1px solid rgba(18, 164, 111, 40%);
//   position: absolute;
//   top: 20px;
//   right: 60px;
//   border-bottom: 1px solid transparent;
// `;

export const HeroCircleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  padding: 0 9rem 0 7rem;
  color: var(--white-color);
  position: relative;
  p {
    font-size: 1.8rem;
    font-weight: 40rem;
    margin-bottom: 2.4rem;
  }
  @media (max-width: 600px) {
    align-items: center;
    & button {
      display: none;
    }
  }
  @media (max-width: 480px) {
    & .button-container {
      width: 100%;
      margin-top: 24px;
      & button {
        display: block;
        background-color: #12a46f;
        color: var(--bg-white);
      }
    }
    padding: 0;
  }
`;

export const TitleContainer = styled.div`
  height: 112px;
  h1 {
    font-family: Peyda;
    font-style: normal;
    font-weight: 900;
    font-size: 3.6rem;
    line-height: 56px;
  }
  @media (max-width: 600px) {
    width: 209px;
    height: 104px;

    h1 {
      font-weight: 800;
      font-size: 2.2rem;
      line-height: 52px;
    }
  }
  @media (max-width: 480px) {
    width: 100%;
    height: 52px;
    margin-top: 0;
    h1 {
      color: var(--primary-color);
    }
  }
`;

export const TextContainer = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin-top: 0.8rem;
  margin-bottom: 2.4rem;
  @media (max-width: 1350px) {
    width: 100%;
  }
  @media (max-width: 600px) {
    width: ${(props) => props.width600 || "232px"};
    height: ${(props) => props.height600 || "128px"};
    margin-top: 0;
  }
  @media (max-width: 480px) {
    width: ${(props) => props.width480 || "100%"};
    height: ${(props) => props.height600 || "96px"};
    margin-top: 2.4rem;
    margin-bottom: 0;
    p {
      z-index: 10;
    }
  }

  p {
    font-weight: 400;
    font-family: Peyda;
    font-size: 1.8rem;
    line-height: 3.2rem;
    color: var(--white-color);
    @media (max-width: 600px) {
      font-size: 1.6rem;
      font-weight: 500;
    }
    @media (max-width: 480px) {
      color: var(--text-400);
    }
  }
`;

export const HeroBg = styled.div`
  background: url(${greenbor}) no-repeat;
  width: 670px;
  height: 670px;
`;
